"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var ResponsiveDisplay = function ResponsiveDisplay(_ref) {
  var componentToDisplay = _ref.componentToDisplay,
    bfMinWidth = _ref.bfMinWidth,
    bfMaxWidth = _ref.bfMaxWidth;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  (0, _react.useLayoutEffect)(function () {
    var updateSize = function updateSize() {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", updateSize);
    updateSize();
    return function () {
      return window.removeEventListener("resize", updateSize);
    };
  });
  var correctMinBreak = parseInt(_bfBaseStyles.Breakpoints[bfMinWidth]);
  var correctMaxBreak = parseInt(_bfBaseStyles.Breakpoints[bfMaxWidth]);
  if (bfMinWidth && bfMaxWidth) {
    return correctMinBreak < width && width < correctMaxBreak && componentToDisplay;
  } else if (bfMinWidth) {
    return correctMinBreak < width && componentToDisplay;
  } else if (bfMaxWidth) {
    return correctMaxBreak > width && componentToDisplay;
  } else {
    return componentToDisplay;
  }
};
ResponsiveDisplay.propTypes = {};
var _default = ResponsiveDisplay;
exports.default = _default;